import {Accordion} from '@sdox/ui'
import {useFragmentHelpers} from '@sdox/api'

import {BlockAccordionSectionItems} from './BlockAccordionSectionItems'
import {PanelContext} from '../../../context/PanelContext'

import type {XcNwBlock_BlockAccordionType_Fragment} from '@sdox/api'

type BlockAccordionSectionType = XcNwBlock_BlockAccordionType_Fragment['sections'][number]

export const BlockAccordionSection = (props: BlockAccordionSectionType) => {
  const {usePanel} = useFragmentHelpers()
  const panel = usePanel(props.panel.id)

  return (
    <PanelContext.Provider value={{panels: [panel]}}>
      <Accordion
        title={props.title}
      >
        <BlockAccordionSectionItems
          blocks={panel.blocks}
        />
      </Accordion>
    </PanelContext.Provider>
  )
}
